import { useCallback, useState } from 'react';
import {
  clearBatchProgress,
  initBatchProgress,
  runWithProgress,
  tickBatchProgress,
} from '../utils/batchProgress';

export function useCopyProgress() {
  const [copyProgress, setCopyProgress] = useState(null);

  const wrapCopy = useCallback(async (title, total, run) => {
    return runWithProgress(setCopyProgress, { title, total, run });
  }, []);

  return {
    copyProgress,
    setCopyProgress,
    wrapCopy,
    initCopyProgress: (options) => initBatchProgress(setCopyProgress, options),
    tickCopyProgress: (options) => tickBatchProgress(setCopyProgress, options),
    clearCopyProgress: () => clearBatchProgress(setCopyProgress),
  };
}
